import axios from "axios";
import { SERVER_URL } from "./../env";

export default {
  state: {
    articlesAreLoading: false,
    articlesAreErrored: false,
    articles: [],
    articlesCount: 0,
    isSearch: false,
    search: "",
    tags: []
  },

  getters: {
    articlesAreLoading: state => state.articlesAreLoading,
    articlesAreErrored: state => state.articlesAreErrored,
    articles: state => state.articles,
    articlesCount: state => state.articlesCount,
    searchStatus: state => state.isSearch,
    searchQuery: state => state.search,
    tags: state => state.tags
  },

  mutations: {
    articlesAreLoading: state => {
      state.articlesAreLoading = true;
    },
    articlesAreLoaded: state => {
      state.articlesAreLoading = false;
    },
    articlesAreErrored: state => {
      state.articlesAreErrored = true;
    },
    setArticles: (state, payload) => {
      state.articles.push(...payload);
    },
    clearArticles: state => {
      state.articles = [];
      state.articlesCount = 0;
    },
    setArticlesCount: (state, payload) => {
      state.articlesCount = payload;
    },
    clearSearchQuery: state => {
      state.search = "";
    },
    setTags: (state, payload) => {
      state.tags = payload;
    },
    articleModerated: (state, postId) => {
      state.articles = state.articles.filter(a => a.id !== postId);
      state.articlesCount--;
    }
  },

  actions: {
    async getArticles({ commit, dispatch }, url) {
      commit("articlesAreLoading");
      try {
        const res = await axios.get(`${SERVER_URL}/api/post${url}`);
        commit("setArticles", res.data.posts);
        commit("setArticlesCount", res.data.count);
      } catch (e) {
        dispatch("setHttpError", e);
        commit("articlesAreErrored");
      } finally {
        commit("articlesAreLoaded");
      }
    },

    async moderateArticle({ dispatch, commit }, payload) {
      try {
        const res = await axios.post(`${SERVER_URL}/api/moderation`, payload);
        if (res.status === 401) this.$router.push("/");
        else commit("articleModerated", payload.post_id)
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async getTags({ commit, dispatch }) {
      try {
        const res = await axios.get(`${SERVER_URL}/api/tag`);
        commit("setTags", res.data.tags);
      } catch (e) {
        dispatch("setHttpError", e);
      }
    }
  }
};
